<h1 mat-dialog-title class="p-2 text-center">Nouveau Comptage</h1>
<div class="container-fluid p-3">

    <div class="row my-3">
        <mat-form-field class="col" cdkFocusRegionStart>
            <mat-label>Recherche Critère faunistique - floristique</mat-label>
            <input matInput placeholder="Recherche Critère faunistique - floristique" [(ngModel)]="SearchText" [matAutocomplete]="auto" (keyup)="onKeyUp()" [focus]="IsFocused"
                   (keyup.enter)="onConfirm()" cdkFocusInitial>
            <button appPreventDoubleClick *ngIf="SearchText" matSuffix mat-icon-button aria-label="Clear" (throttledClick)="SearchText=''">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setSelectedTaxon($event)" [displayWith]="displayFn">
            <mat-option *ngFor="let option of TaxonOptionList" [value]="option">
                <!-- <span *ngIf="!CoreData.IsOffline">
                    {{option.Code}} - {{option?.Ordre && option?.Ordre !== '' ? option?.Ordre + ' /' : ''}} {{option?.Famille !== '' ? option?.Famille + ' /' : ''}} {{option?.Genre}}
                </span> -->
                <span>
                    {{option.Code}} - {{option?.Genre}}
                </span>
            </mat-option>
        </mat-autocomplete>
    </div>

    <div class="row align-items-center text-center m-3" >
        <div class="col-6">
            Quantité actuelle {{model.Quantite}}
        </div>
        <mat-form-field class="col" *ngIf="model.IsPhyto || model.Colonie < 30">
            <mat-label>Nouvelle Quantité</mat-label>
            <input matInput placeholder="Nouvelle Quantité" type="number" [(ngModel)]="NewQuantite">
        </mat-form-field>
    </div>

    <div class="row align-items-center text-center m-3" cdkFocusRegionEnd>
        <div class="col-6">
            Colonie actuelle {{model.Colonie}}
        </div>
        <mat-form-field class="col" *ngIf="model.IsPhyto || model.Colonie >= 30">
            <mat-label>Ajouter une nouvelle colonie</mat-label>
            <input matInput placeholder="Ajouter une nouvelle colonie" type="number" [(ngModel)]="NewColonie" [readonly]="!model.IsPhyto">
        </mat-form-field>
    </div>

    <div class="row">
        <button appPreventDoubleClick class="col-6 squared-flat-button" color="primary" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col-6 squared-flat-button" color="warn" mat-stroked-button (throttledClick)="onConfirm()" [disabled]="!CanAdd">
            Sauvegarder
        </button>
    </div>
</div>